import { isValidElement } from 'react';
import type { IApplicationSlice } from '@alfa-bank/site-dc-form-api/src/store/features/models';

import type {
    TExceptions,
    IDcFormPublicDesktopProps,
    IDcFormPublicMobileProps,
    IDcFormProps,
} from '../models';
/**
 * Очищает строку от всего кроме цифр
 * пример +7 (999) 333-55-66 -> 79993335566
 */
export const formatPhoneValue = (phone: string) => {
    const regexp = new RegExp(/\D/, 'g');

    return phone.replace(regexp, '');
};

/** Форматируем и убираем "7" у телефона */
export const preparePhoneValue = (phone: string) =>
    +formatPhoneValue(phone.toString()).substring(1);

/** Возвращает мобильный девайс если он есть в userAgent */
export const getNamedContainerKey = (obj: TExceptions, userAgent: string) => {
    return Object.keys(obj)
        .reduce((acc, key) => {
            acc = obj[key].some(el => {
                return userAgent.toLowerCase().includes(el.toLocaleLowerCase());
            })
                ? key
                : acc;

            return acc;
        }, '')
        .toLowerCase();
};

/** Фильтрует пропсы, которые будут записаны в стор от функций и реакт-элементов */
export function getClearProps(props: IDcFormProps): IApplicationSlice['appConfig'] {
    return Object.entries(props).reduce((acc, [propName, prop]) => {
        if (typeof prop === 'function' || isValidElement(prop) || propName === 'children') {
            return acc;
        }

        return {
            ...acc,
            [propName]: prop,
        };
    }, {} as IDcFormPublicMobileProps | IDcFormPublicDesktopProps);
}
